namespace $.$$ {

	$mol_style_define( $bog_gram_scan, {
		flex: { direction: 'column' },
		gap: $mol_gap.text,

		Camera: {
			width: '100%',
			maxWidth: '20rem',
			aspectRatio: 1,
			objectFit: 'cover',
			border: { radius: $mol_gap.round },
		},
	} )

}
